<div *ngFor="let item of items">
  <app-mobile-content-block [item]="item"></app-mobile-content-block>
</div>
